import { render, staticRenderFns } from "./externalKeyboardOptions.vue?vue&type=template&id=8b6b7df2&scoped=true&"
import script from "./externalKeyboardOptions.vue?vue&type=script&lang=js&"
export * from "./externalKeyboardOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6b7df2",
  null
  
)

export default component.exports